<template>
    <app-modal-prompt
        persistent 
        width="1000"
        :value="dialog"
        :is-confirm-button-disabled="disabled"
        :loading="loading_massive_changes"
        :buttons-on-top="buttonsOnTop"
        :is-header-fixed="true"
        @confirm="save()"
        @cancel="cancel()"
        @input="e => $emit('input', e)"
    >
        <template #title>
            Seleccione los campos que desea cambiar de forma masiva
        </template>
        <slot name="inputs"></slot>
    </app-modal-prompt >
</template>

<script>
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';

export default {
    name: 'MassiveChangesPopUp',

    components: {
        AppModalPrompt,
    },

    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading_massive_changes:{
            type: Boolean,
            required: false,
            default: false,
        },
        buttonsOnTop: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods:{
        cancel() {
            this.$emit("close-popup");
        },
        save() {
            this.$emit("save-massive-changes");
        }
    }
}
</script>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
</style>
